/* eslint-disable strict */
/* eslint-disable newline-per-chained-call */

'use strict';

(function BlogFunctions() {
  $(document).ready(function () {
    // Mobile Nav Toggle
    $('[data-blog-menu]').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $('[data-blog-menu-list]').slideUp(200);
        $(this).removeClass('active');
      } else {
        $('[data-blog-menu-list]').slideDown(200);
        $(this).addClass('active');
      }
    });

    // Mobile Sub Nav Toggle
    $('[data-blog-menu-list] a.top-level').on('click', function (e) {
      e.preventDefault();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active').parent().find('[data-blog-sub-list]').slideUp(200);
      } else {
        $(this).addClass('active').parent().find('[data-blog-sub-list]').slideDown(200);
      }
    });

    // Desktop Sub Nav Toggle
    $('[data-desktop-nav] a.top-level').on('click', function (e) {
      var $this = $(this);
      e.preventDefault();
      if ($this.hasClass('active')) {
        $this.removeClass('active').parent().find('[data-desktop-sub-list]').slideUp(100);
      } else {
        $('[data-desktop-nav] a.top-level').each(function () {
          $(this).removeClass('active').parent().find('[data-desktop-sub-list]').slideUp(100);
        });
        $this.addClass('active').parent().find('[data-desktop-sub-list]').slideDown(100);
      }
    });

    // Load More Articles
    $('[data-load-more]').on('click', function (e) {
      var $this = $(this);
      var currentPage = parseInt($this.data('current-page'), 10);
      var maxPage = parseInt($this.data('max-page'), 10);
      var nextPage = currentPage + 1;
      var nextUrl = $this.attr('href');
      var currentUrl = nextUrl.substring(0, nextUrl.indexOf('?page='));
      var failTitle = $this.data('load-fail-title');
      var failText = $this.data('load-fail-text');
      var lookupUrl = currentUrl + '?page=' + nextPage;
      var articleContainer = $('[data-main-articles]');
      e.preventDefault();

      function removeLoadMore() {
        $this.data('current-page', maxPage);
        $('[data-load-more-section]').fadeOut('400');
      }

      if (!$this.hasClass('loading')) {
        $this.addClass('loading');
        if (nextPage <= maxPage) {
          $.ajax({
            url: lookupUrl,
            type: 'GET',
            success: function (response) {
              // eslint-disable-next-line prettier/prettier
              var html = $(response).find('[data-main-articles]').html();
              articleContainer.append(html);
              if (nextPage === maxPage) {
                removeLoadMore();
              } else {
                $this.data('current-page', nextPage);
                $this.removeClass('loading');
              }
            },
            error: function () {
              articleContainer.append(
                '<h3 class="w-full block text-center text-dark mt-40">' +
                  failTitle +
                  '</h3><p class="w-full block text-center max-w-600 text-dark mx-auto">' +
                  failText +
                  '</p>'
              );
              removeLoadMore();
            }
          });
        } else {
          removeLoadMore();
        }
      }
    });
  });
})();
